import { HashRouter as Router } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Loader from "./components/Loader";
import DohrniiRoutes from "./routes/DohrniiRoutes";
import ScrollToTop from "./components/ScrollToTop";
import "./styles/core.scss";

import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  // useEffect(() => {
  //   window.jQuery = $;
  //   window.$ = $;
  //   const loadScript = (src) => {
  //     return new Promise((resolve, reject) => {
  //       const script = document.createElement("script");
  //       script.src = src;
  //       script.async = true;
  //       script.onload = resolve;
  //       script.onerror = reject;
  //       document.body.appendChild(script);
  //     });
  //   };
  //   const loadScripts = async () => {
  //     try {
  //       await loadScript("./assets/js/jquery.sticky.js");
  //       await loadScript("./assets/js/click-scroll.js");
  //       await loadScript("./assets/js/counter.js");
  //       await loadScript("./assets/js/custom.js");
  //     } catch (error) {
  //       console.error("Error loading scripts:", error);
  //     }
  //   };

  //   loadScripts();
  // }, []);

  return (
    <Router>
      <ScrollToTop />

      <Header />
      <DohrniiRoutes />
      <Loader isVisible={false} />
      <Footer />
    </Router>
  );
}

export default App;
